<template>
  <div class="image-contain">
    <a :href="`${site}/${val}`" target="_blank">{{site}}/{{val}}</a>

    <span @click="clear()">
      <IconClear />
    </span>
  </div>
</template>

<script>
import { global } from "@/global";
export default {
  props: {
    value: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      val: this.value,
      site: `${global["API"]}/${global["UPLOADFOLDER"]}`,
    };
  },
  methods: {
    clear: function () {
      this.val = "";
      this.$emit("input", "");
    },
  },
};
</script>

<style lang="scss" scoped>
.image-contain {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;

  margin-bottom: 32px;

  img {
    border-radius: var(--radius);
  }

  span {
    padding: 4px;
    cursor: pointer;
  }
}
</style>